import { render } from "./FollowAuthorBtn.vue?vue&type=template&id=9c911ae6&scoped=true"
import script from "./FollowAuthorBtn.vue?vue&type=script&lang=js"
export * from "./FollowAuthorBtn.vue?vue&type=script&lang=js"

import "./FollowAuthorBtn.vue?vue&type=style&index=0&id=9c911ae6&lang=scss&scoped=true"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c911ae6"]])

export default __exports__